import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import ShopDetailsMain from '../components/main/ShopDetailsMain';
import userApi from '../api/userApi';

const ShopDetails = () => {
  const { id } = useParams(); 
  const [productDetail, setProductDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProductDetail = async () => {
      try {
        const product = await userApi.getProductById(id); 
        setProductDetail(product);
      } catch (error) {
        console.error('Error fetching product detail:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProductDetail();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!productDetail) {
    return <div>Product not found</div>;
  }

  return (
    <Layout>
      <ShopDetailsMain productDetail={productDetail} />
    </Layout>
  );
};

export default ShopDetails;
